import { z } from 'zod'

import { Flag } from './Flag'

export const FlagList = Flag.array()
export type FlagList = z.infer<typeof FlagList>
